import _ from 'lodash'
import store from '@/store'
import * as types from '@/store/types'
import SimpleVueValidator from 'simple-vue-validator';
const Validator = SimpleVueValidator.Validator;

const userDashboardMixin = {

    validators: {
      'selectedStatusId': function (value) {
        return Validator.custom(function () {
          if (value === null) {
              return 'NV# not found in database.'
          }          
        })
      },
      'selectedRequestTypeId': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'selectedCentcomConsentId': function (value) {
        return Validator.custom(function () {
          if (value == null || Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'selectedOrgAnonymousId': function (value) {
        return Validator.custom(function () {
          if (value == null || Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
       'selectedDate': function (value) {
        return Validator.custom(function () {
          if (value == null || Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },      
      'selectedEmergencyId': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      // 'nvNumber': function (nvNumber) {
      //   return Validator.custom(function () {
      //     if (Validator.isEmpty(nvNumber)) {
      //         return 'This is a required field.'
      //     }
      //   })
      // },
      'notes': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      }
    }
  }

export default userDashboardMixin


// WEBPACK FOOTER //
// ./src/mixins/validators/UserDashboard-validators.js